import { cardPageController, translate } from 'magner';
import {
  sportsTourneyCreate,
  sportsTourneyDelete,
  sportsTourneyGet,
  sportsTourneyUpdate,
} from 'features/profile/sports/tourney/requests';
import { SportsTourneyFull } from 'features/profile/sports/tourney/types';

const sportsTourneyConfig = cardPageController<SportsTourneyFull>({
  getRequest: sportsTourneyGet,
  createRequest: sportsTourneyCreate,
  updateRequest: sportsTourneyUpdate,
  deleteRequest: sportsTourneyDelete,

  header: {
    title: translate('gaz.sports.tourney.form.title_create'),
  },

  form: {
    actions: [
      {
        type: 'action',
        emits: 'submit',
        props: {
          type: 'primary',
          text: translate('gaz.sports.tourney.form.submit_button'),
        },
      },
      {
        type: 'action',
        emits: 'remove',
        props: {
          type: 'danger',
          text: translate('gaz.sports.tourney.form.remove_button'),
        },
      },
    ],
    layout: {
      type: 'column',
      props: {},
      fields: [
        {
          type: 'input',
          name: 'title',
          label: translate('gaz.sports.tourney.form.name.label'),
          props: {
            required: true,
            placeholder: translate('gaz.sports.tourney.form.name.placeholder'),
            maxLength: 50,
            showLetterLimit: true,
          },
          validation: [{
            type: 'empty',
            trigger: 'blur',
          }],
        },

        {
          type: 'textarea',
          name: 'description',
          label: translate('gaz.sports.tourney.form.description.label'),
          props: {
            required: true,
            placeholder: translate('gaz.sports.tourney.form.description.placeholder'),
            maxLength: 3000,
            showLetterLimit: true,
            rows: 5,
          },
          validation: [{
            type: 'empty',
            trigger: 'blur',
          }],
        },

        {
          type: 'dropzone',
          name: 'image',
          dataType: 'number',
          label: translate('gaz.sports.tourney.form.image.label'),
          props: {
            valueKey: 'id',
            srcKey: 'image',
            removable: true,
          },
        },
      ],
    },
  },
});

export default sportsTourneyConfig;
